import React from "react";
import {useStyles} from "./styles/DialogStyle";
import {inject, observer} from "mobx-react";
import {Close} from '@material-ui/icons';
import {Box, Button, Dialog, DialogContent, IconButton, Typography} from "@material-ui/core";
import clsx from "clsx";
import {injectIntl} from "react-intl";


function CommonDialog(props) {
    const classes = useStyles();
    const {intl} = props;

    const {
        dialogOpen,
        dialogClose,
        titleText,
        contents,
        text,
        controlBtn,
        clickButton,
        controlBtnText,
        disabledButton
    } = props;

    return (
        <Dialog
            open={dialogOpen}
            className={classes.dialogBox}
        >
            <Box
                className={classes.dialogTopBar}
            >
                <Typography className={classes.titleText}>{titleText}</Typography>
                <IconButton className={classes.iconButton} onClick={dialogClose} disableRipple>
                    <Close/>
                </IconButton>
            </Box>
             <DialogContent dividers={!!titleText}>
                <Box className={classes.contentsBox}>

                    {contents}

                    {controlBtn &&
                        <Box display='flex' justifyContent='flex-end' alignItems='center'
                             className={classes.controlBox}>
                            <Box className={classes.controlBoxText}>
                                {text}
                            </Box>
                            <Button className={clsx(classes.buttonStyle, classes.buttonStyleCancle)} onClick={dialogClose}
                                    disabled={!!disabledButton ? disabledButton : false} disableRipple>
                                {intl.formatMessage({id: "cancel"})}
                            </Button>
                            <Button className={classes.buttonStyle} onClick={clickButton}
                                    disabled={!!disabledButton ? disabledButton : false} disableRipple>
                                {controlBtnText ?
                                    controlBtnText
                                    :
                                    intl.formatMessage({id: "confirm"})
                                }
                            </Button>
                        </Box>
                    }
                </Box>
            </DialogContent>

        </Dialog>
    );
}

export default inject('dialogStore')(injectIntl(observer(CommonDialog)));
